import { Avatar, Card, Empty } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Row } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ViewAssociatedProjects = ({ fullData }: any) => {
  const [dataSource, setDataSource] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  useEffect(() => {
    if (fullData) {
      const projects = fullData?.projects || [];
      setDataSource(projects);
    }
  }, [fullData]);
  const getColorFromName = (name: string) => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = hash % 360; // Full hue spectrum
    const color = `hsl(${hue}, 90%, 70%)`; // Bright and colorful
    return color;
  };
  return (
    <>
      {dataSource.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "350px",
          }}
        >
          <Empty
            style={{}}
            description="No project is associated with this Calendar"
          />
        </div>
      ) : (
        <div className="card-inner card-inner-lg p-0">
          <div className="content clearfix">
            <div style={{ padding: "20px" }}>
              <Row className="g-gs">
                <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                  {dataSource?.map((project: any) => {
                    return (
                      <Card
                        key={project.projectId}
                        style={{
                          width: 320,
                          borderRadius: 10,
                          backgroundColor: "#fff",
                          border: "1px solid #e0e0e0",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          padding: 16,
                          position: "relative",
                          transition: "all 0.3s ease",
                          cursor: "pointer",
                        }}
                        bodyStyle={{
                          display: "flex",
                          alignItems: "center",
                          padding: 0,
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                          e.currentTarget.style.borderColor = "#277af7";
                          e.currentTarget.style.boxShadow =
                            "0 4px 12px rgba(39, 122, 247, 0.15)";
                          e.currentTarget.style.transform = "translateY(-2px)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#fff";
                          e.currentTarget.style.borderColor = "#e0e0e0";
                          e.currentTarget.style.boxShadow =
                            "0 2px 8px rgba(0,0,0,0.1)";
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                      >
                        <Avatar
                          size={40}
                          style={{
                            backgroundColor: getColorFromName(
                              project.projectTitle
                            ),
                            fontWeight: "bold",
                            fontSize: 18,
                            marginRight: 16,
                          }}
                        >
                          {project.projectTitle
                            .split(" ")
                            .map((word: any) => word[0])
                            .join("")
                            .toUpperCase()
                            .slice(0, 2)}
                        </Avatar>
                        <div style={{ flex: 1 }}>
                          <div
                            onClick={() => {
                              let allowEdit = true;
                              if (project?.lock) {
                                if (project?.lockedBy != currentUser?.id)
                                  allowEdit = false;
                              }
                              navigate("/pms/project/dashboard", {
                                state: {
                                  id: project?.projectId,
                                  derivedProjectStatus:
                                    project?.derivedProjectStatus,
                                  projectName: project?.projectTitle,
                                  extra: {
                                    screenName: "Active",
                                    lock: project?.lock,
                                    allowEdit,
                                    lockedOn: project?.updatedAt
                                      ? dayjs(project?.updatedAt).format(
                                          "DD-MMM-YYYY"
                                        )
                                      : dayjs(project?.createdAt).format(
                                          "DD-MMM-YYYY"
                                        ),
                                    currentUserId: currentUser?.id,
                                    lockedBy: project?.lockedBy,
                                    lockedByUserName:
                                      project?.lockedByUserName || "N/A",
                                    plannedStartDate: project?.plannedStartDate,
                                    plannedEndDate: project?.plannedEndDate,
                                    siteId: project?.siteId,
                                    siteName: project?.siteName,
                                  },
                                },
                              });
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <div style={{ fontWeight: 500 }}>
                              {project.projectTitle}
                            </div>
                            <div style={{ color: "#888" }}>
                              Project Status : {project.projectStatus}
                            </div>
                            <div style={{ color: "#888" }}>
                              Created By : {project.createdByUserName}
                            </div>
                            <div style={{ color: "#888" }}>
                              Created At :{" "}
                              {project.createdAt
                                ? dayjs(project.createdAt).format("DD-MMM-YYYY")
                                : "--"}
                            </div>
                          </div>
                        </div>
                      </Card>
                    );
                  })}
                </div>
              </Row>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewAssociatedProjects;
